<template>
  <b-modal centered ref="modal-send-excel" v-model="showModalSendExcel" title="Enviar Excel">
    <b-form-group label="Email" label-for="excel-email">
      <b-form-input id="excel-email" v-model="to" type="email" placeholder="Digite o email para envio" required></b-form-input>
    </b-form-group>
    <template #modal-footer>
      <div class="w-100 text-right">
        <button type="button" class="btn btn-third btn-sm" @click="sendExcel">
          <i class="fas fa-check-circle"></i><span class="d-md-down-none"> Enviar</span>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import NumRepository from '@/shared/http/repositories/access/cadastroNum'
import ReportAtendimentoRepository from '@/shared/http/repositories/crm/reportAtendimento.js'

export default {
  name: 'SendExcelModal',
  data () {
    return {
      showModalSendExcel: false,
      to: '',
      selectedProvider: '',
      types: [],
      filters: {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        identifierProvider: null,
        dataInicial: null,
        dataFinal: null,
        operadores: null,
        status: 'Finalizado',
        page: 1,
        pageSize: 10,
        protocols: null
      }
    }
  },
  created () {
    this.loadProviders()
  },
  methods: {
    async loadProviders () {
      try {
        const requestConfig = {
          params: {
            active: 1
          }
        }
        const response = await NumRepository.getEnvAll(requestConfig)
        this.types = response.data.content
      } catch (error) {
        console.error('Erro ao carregar provedores:', error)
      }
    },
    openModal (filters) {
      this.to = ''
      this.filters = filters
      this.showModalSendExcel = true
    },
    closeModal () {
      this.showModalSendExcel = false
    },
    async sendExcel () {
      try {
        const response = await ReportAtendimentoRepository.SendExcel(
          this.filters,
          this.to
        )
        if (response.status === 200) {
          this.$bvToast.toast('Excel enviado com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true
          })
        }
      } catch (error) {
        console.error('Erro ao enviar Excel:', error)
        this.$bvToast.toast('Erro ao enviar Excel.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.closeModal()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/relatorios_atendimento/modal/SendExcel.vue